webpackJsonp([152837369890290],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BannerLanding = __webpack_require__(5);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _BannerSection = __webpack_require__(6);
	
	var _BannerSection2 = _interopRequireDefault(_BannerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Masses = function Masses(props) {
	  var _props$data$contentfu = props.data.contentfulMasses,
	      title = _props$data$contentfu.title,
	      metaDescription = _props$data$contentfu.metaDescription,
	      headerBackgroundImage = _props$data$contentfu.headerBackgroundImage,
	      sectionFourHeading = _props$data$contentfu.sectionFourHeading,
	      sectionFourContent = _props$data$contentfu.sectionFourContent;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'main', className: 'alt-colors' },
	    _react2.default.createElement(_BannerLanding2.default, {
	      title: title,
	      desc: metaDescription,
	      bg: headerBackgroundImage !== null ? headerBackgroundImage.file.url : undefined
	    }),
	    _react2.default.createElement(
	      'section',
	      { id: 'section-four' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_BannerSection2.default, { sectionContent: sectionFourHeading })
	        ),
	        sectionFourContent !== null ? _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: sectionFourContent.childMarkdownRemark.html
	          }
	        }) : undefined
	      )
	    ),
	    _react2.default.createElement('hr', null)
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	// import YouTube from 'react-youtube'
	
	
	Masses.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = Masses;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.massesQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Masses = __webpack_require__(165);
	
	var _Masses2 = _interopRequireDefault(_Masses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MassesPage = function MassesPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Masses | ' + props.data.site.siteMetadata.title
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: props.data.contentfulMasses.metaDescription
	      })
	    ),
	    _react2.default.createElement(_Masses2.default, { data: props.data })
	  );
	};
	
	// components
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	MassesPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = MassesPage;
	var massesQuery = exports.massesQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-masses-js-e7d97dcebd75f0757fd6.js